module.exports = __webpack_public_path__ + "static/media/ху.69d5ed4c.mp3";